import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  explore: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gap: 16,
  },
}));

export default useStyles;
